import script from "./BaseDateField.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDateField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__